import { tableNoRows } from '../svg-icon-templates';

// For some reason, ag-grid can't have the template string tickmarks on their own lines
export default `<div class="no-table-rows--container">
  <div class="no-table-rows--illo">${tableNoRows}</div>
  <div class="no-table-rows--content">
    <h4>No results</h4>
  </div>
</div>`;
